import { CalendarDays, Layers, Coffee } from "lucide-react";
import { ScrollReveal } from "./Reveal";

const STEPS = [
  {
    icon: CalendarDays,
    date: "15 octombrie 2026",
    title: "Startul anului școlar 2026–2027",
    text: "Deschidem porțile — 門 — unui nou an de japoneză, pentru toate nivelurile și toate vârstele.",
  },
  {
    icon: Layers,
    date: "3 module",
    title: "Minimum 14 lecții pe modul",
    text: "Fiecare modul are cel puțin 14 ședințe a câte 1h30 — ritm constant, progres vizibil.",
  },
  {
    icon: Coffee,
    date: "Pauze",
    title: "Doar de sărbătorile legale",
    text: "Învățarea e un drum continuu — ne oprim doar în zilele de sărbătoare legală.",
  },
];

export default function Program() {
  return (
    <section id="program" data-testid="program-section" className="relative py-20 sm:py-32 bg-sumi text-washi overflow-hidden">
      <span aria-hidden className="pointer-events-none select-none absolute right-4 top-16 vertical-rl font-jp text-8xl text-washi/[0.05] hidden sm:block">
        年間予定
      </span>

      <div className="max-w-7xl mx-auto px-4 sm:px-8">
        <ScrollReveal>
          <p className="text-xs font-mono tracking-[0.3em] uppercase text-hanko mb-4">Program 2026–2027</p>
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl leading-tight max-w-3xl">
            Un an școlar, <span className="italic text-hanko">un drum</span> — 道.
          </h2>
        </ScrollReveal>

        <div className="mt-16 relative">
          <span aria-hidden className="absolute left-[19px] sm:left-1/2 top-2 bottom-2 w-px bg-washi/15" />
          <div className="space-y-12 sm:space-y-16">
            {STEPS.map((s, i) => {
              const Icon = s.icon;
              const left = i % 2 === 0;
              return (
                <ScrollReveal key={s.title} delay={0.05}>
                  <div
                    data-testid={`program-step-${i + 1}`}
                    className={`relative grid sm:grid-cols-2 gap-4 sm:gap-16 items-start pl-14 sm:pl-0`}
                  >
                    <span className="absolute left-0 sm:left-1/2 top-0 sm:-translate-x-1/2 w-10 h-10 rounded-full bg-sumi border border-hanko flex items-center justify-center z-10">
                      <Icon size={17} className="text-hanko" />
                    </span>
                    <div className={left ? "sm:text-right sm:pr-4" : "sm:col-start-2 sm:pl-4"}>
                      <p className="text-[11px] font-mono tracking-[0.25em] uppercase text-hanko">{s.date}</p>
                      <h3 className="mt-2 font-serif text-xl sm:text-2xl">{s.title}</h3>
                      <p className={`mt-2 text-sm sm:text-base text-washi/65 leading-relaxed max-w-md ${left ? "sm:ml-auto" : ""}`}>
                        {s.text}
                      </p>
                    </div>
                  </div>
                </ScrollReveal>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
